/* global  */ // tUrl等のグローバル変数を宣言する
import scrollLock from './functions/_scrollLock.js' // スクロールロック

import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言

if (document.getElementById('enjoy')) {
  pageEnjoy()
}

function pageEnjoy() {
  //  ###    ###  #####  ##     ##  ##   ##
  //  ## #  # ##  ##     ####   ##  ##   ##
  //  ##  ##  ##  #####  ##  ## ##  ##   ##
  //  ##      ##  ##     ##    ###  ##   ##
  //  ##      ##  #####  ##     ##   #####
  if (document.getElementById('enjoyMenu')) {
    if (navigator.userAgent.match(/MSIE 10/i) || navigator.userAgent.match(/Trident\/7\./)) {
      // IEは瞬時に処理すると一部崩れるのでウェイトをかける
      setTimeout(function () {
        enjoyMenu()
      }, 300)
    } else {
      enjoyMenu()
    }
  }

  function enjoyMenu() {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const slideItem = document.getElementById('enjoyMenu')
    const sliderName = 'enjoyMenu'
    const enjoyMenuSwiper = new Swiper(slideItem, {
      // init: false, // 自動で初期化しない（enjoyMenuSwiper.init()で初期化）
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      preloadImages: false, // スライド内の画像を読み終えてから開始
      touchRatio: 0, // タッチスワイプ感度（0でタッチスワイプ無効）
      autoHeight: true, // スライドごとに高さを変動させる
      fadeEffect: {
        // フェードオプション
        crossFade: true, // クロスフェード
      },

      pagination: {
        // ページャーオプション
        el: '.swiper-pagination--' + sliderName, // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true, // クリックでジャンプ可能にする
        renderBullet: function (index, className) {
          // bulletsの描画内容を改変
          const targetImage = document.querySelector('[data-swiper-slide-index="' + index + '"] .js-slideBtn')
          return '<div class="' + className + '">' + targetImage.innerHTML + '</div>'
        },
      },

      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },
      // breakpoints: {
      //   // 指定px以上でオプション切り替え
      //   769: {},
      // },
    })
  }

  //  ###    ###   #####   ####      ###    ##
  //  ## #  # ##  ##   ##  ##  ##   ## ##   ##
  //  ##  ##  ##  ##   ##  ##  ##  ##   ##  ##
  //  ##      ##  ##   ##  ##  ##  #######  ##
  //  ##      ##   #####   ####    ##   ##  ######

  const modalOverlay = document.getElementById('modalOverlay') // モーダル用オーバーレイ
  const modals = document.getElementsByClassName('js-modal') // モーダル本体
  const modalYoutube = document.getElementsByClassName('js-modal-youtube') // モーダル内YouTube
  if (modals[0]) {
    window.addEventListener('click', (e) => {
      if (!e.target.closest('.js-modal-open')) {
        return
      }
      e.preventDefault()
      modalClose()
      const target = e.target.closest('.js-modal-open').dataset.modal

      const openModals = document.querySelectorAll('.js-modal--' + target)
      for (const openModal of openModals) {
        openModal.classList.add('active')
      }

      modalOverlay.classList.add('active')
      scrollLock('body', '#modalOverlay')

      // YouTubeのsrcを読み込む
      const youtube = document.querySelector('.js-modal--' + target + ' .js-modal-youtube')
      if (youtube) {
        youtube.setAttribute('src', youtube.dataset.src)
      }
    })
    // モーダル撤去
    window.addEventListener('click', (e) => {
      if (!e.target.closest('.js-modal-close')) {
        return
      }
      e.preventDefault()
      modalClose()
      modalOverlay.classList.remove('active')
      scrollLock('body', '#modalOverlay')
    })
  }

  function modalClose() {
    // モーダルを消す
    for (let index = 0; index < modals.length; index++) {
      const modal = modals[index]
      modal.classList.remove('active')
    }
    // YouTubeのsrcを消して動画を止める
    for (let index = 0; index < modalYoutube.length; index++) {
      modalYoutube[index].setAttribute('src', '')
    }
  }

  /*
   ######   ######          ##    ##    ###    ##     ##
  ##       ##               ####  ##  ##   ##  ##     ##
   ######  ##       ####### ## ## ## ##     ## ##     ##
        ## ##               ##  #### #########  ##   ##
   ######   ######          ##    ## ##     ##    ###

  ターゲットが走査線に入ったら連動する要素にクラスを当てる
  Intersection Observer APIを使用

  <a href="#hoge" class="js-scrollNav js-scrollNav--hoge"></a>
  <section id="hoge" class="js-scrollNav-trigger" data-nav-target="hoge">
    section#hogeが画面に入ったらjs-scrollNav--hogeにクラスを当てる
  </section>
  */

  if (document.getElementsByClassName('js-scrollNav')[0]) {
    scrollNav()
  }
  function scrollNav() {
    const navItems = document.getElementsByClassName('js-scrollNav')
    const intObsOption = {
      rootMargin: '-20% 0px -60% 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
      threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
    }
    const observer = new IntersectionObserver(scrollNavCallback, intObsOption)
    const intObsItems = document.getElementsByClassName('js-scrollNav-trigger')
    for (let index = 0; index < intObsItems.length; index++) {
      const intObsItem = intObsItems[index]
      observer.observe(intObsItem) // 監視対象に加える
    }
    function scrollNavCallback(entries) {
      for (let index = 0; index < entries.length; index++) {
        const entry = entries[index]
        // 接触アイテムを発見
        if (entry.isIntersecting) {
          // 全ての.activeを外す
          for (let index = 0; index < navItems.length; index++) {
            navItems[index].classList.remove('active')
          }
          const entryItem = entry.target
          const target = entryItem.dataset.navTarget // 制御対象名を取得

          // 対象アイテムをアクティブにする
          const targetItems = document.getElementsByClassName('js-scrollNav--' + target)
          for (let index = 0; index < targetItems.length; index++) {
            const targetItem = targetItems[index]
            targetItem.classList.add('active')
          }
          break // 以降の判定は飛ばす
        }
      }
    }
  }

  /*
######## #### ##     ##
##        ##    ## ##
######    ##     ###
##        ##    ## ##
##       #### ##     ##
*/
  // stickyの代替処理
  if (document.getElementById('js-fixArea')) {
    fixArea()
  }
  function fixArea() {
    let isWait = false // 待機フラグ
    let scrollY = window.pageYOffset // 縦方向のスクロール量
    const frame = document.getElementById('js-fixArea') // フレーム
    const item = document.getElementById('js-fixArea-item') // スクロールさせるアイテム
    const adjust = document.getElementById('header').offsetHeight * 1.5 // ヘッダー要素の調整
    let state = 'stay'
    document.addEventListener(
      'scroll',
      function () {
        fixAreaApply()
      },
      { passive: true }
    )
    fixAreaApply()
    function fixAreaApply() {
      if (isWait) {
        return
      }
      isWait = true
      // レンダリング準備が整ったら開始
      requestAnimationFrame(function () {
        scrollY = window.pageYOffset // スクロール量
        const frameHeight = frame.offsetHeight
        const frameTop = frame.getBoundingClientRect().top + scrollY
        const frameBottom = frameTop + frameHeight
        const itemHeight = item.offsetHeight
        const itemTop = item.getBoundingClientRect().top + scrollY
        const itemBottom = itemTop + itemHeight
        // フレームがアイテムより高くなければ終了
        if (frameHeight <= itemHeight) {
          isWait = false // フラグをOFFに戻す
          return
        }

        if (state === 'stay') {
          // スクロールがアイテムのTOPを追い越したら追従
          if (scrollY + adjust >= itemTop) {
            item.classList.add('move')
            state = 'move'
          }
        } else if (state === 'move') {
          if (itemTop <= frameTop) {
            // もとに戻す
            item.classList.remove('move')
            state = 'stay'
          } else if (itemBottom >= frameBottom) {
            // 下につける
            item.classList.remove('move')
            item.classList.add('end')
            state = 'end'
          }
        } else {
          // 下についている
          if (item.getBoundingClientRect().top > adjust) {
            item.classList.remove('end')
            item.classList.add('move')
            state = 'move'
          }
        }
        isWait = false
      })
    }
  }

  //   ####   ####  #####     #####   ##      ##
  //  ##     ##     ##  ##   ##   ##  ##      ##
  //   ###   ##     #####    ##   ##  ##      ##
  //     ##  ##     ##  ##   ##   ##  ##      ##
  //  ####    ####  ##   ##   #####   ######  ######

  /**
   * @function scrollValToggle
   * @description スクロール量を基準にクラスを着脱する
   * @param {String} targetSelector ターゲットとする一意なセレクタ
   * @param {Number} scrollValStart 有効範囲となるスクロール量　上からの距離
   * @param {Number|Boolean} [scrollValEnd=false] 有効範囲外となるスクロール量　下からの距離
   * @param {String} toggleClass 切り替えるクラス名
   * @return {Void}
   */
  scrollValToggle('#js-fixArea-item', 0, 1000, 'active')
  function scrollValToggle(targetSelector, scrollValStart = 500, scrollValEnd = false, toggleClass = 'active') {
    if (!document.querySelector(targetSelector)) {
      return
    }
    let isExecute = false // 実行中フラグ
    let scrollY = 0 // 縦方向のスクロール量
    const target = document.querySelector(targetSelector) // ターゲット要素
    let scToggleActive = false // ターゲット要素のONOFF状態
    document.addEventListener('scroll', function (ev) {
      scrollValToggleApply()
    })
    scrollValToggleApply() // 初回起動
    function scrollValToggleApply() {
      if (isExecute) {
        // 実行中ならスキップ
        return
      }
      isExecute = true
      // レンダリング準備が整ったら開始
      requestAnimationFrame(function () {
        scrollY = window.pageYOffset // スクロール量
        if (scrollY >= scrollValStart && !scToggleActive) {
          //トップから指定px以上スクロールしたらON
          target.classList.add(toggleClass)
          scToggleActive = true
        } else if (scrollY < scrollValStart && scToggleActive) {
          //スクロールが足りない時はOFF
          target.classList.remove(toggleClass)
          scToggleActive = false
        }
        if (scrollValEnd && scToggleActive) {
          // 終了ラインが設定されている場合は終了判定
          if (scrollY + window.innerHeight > document.documentElement.offsetHeight - scrollValEnd) {
            //スクロール終了範囲を過ぎていたらOFF
            target.classList.remove(toggleClass)
            scToggleActive = false
          }
        }
        isExecute = false
      })
    }
  }
}
